import { Component, ViewChild, OnDestroy } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SubSink } from "subsink";

import { ZoneItem } from "@/shared-module/components/zone/zone-item";
import { DialogService, ZoomService } from "@/shared-module/services";

@Component({
  selector: "app-dialog",
  templateUrl: "dialog.component.html",
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class DialogComponent implements OnDestroy {
  modalZones: ZoneItem[] = [];
  subs = new SubSink();
  displayPeriodSelector: boolean;
  maxPeriod: number;
  selectedPeriod: number;
  zoomInfo: any;
  texts: any;
  title: string;
  @ViewChild("content", { static: true }) content;

  constructor(
    private modalService: NgbModal,
    private dialogService: DialogService,
    private zoomService: ZoomService,
  ) {
    this.subs.sink = this.dialogService
      .getZoomInfo()
      .subscribe((s) => this.open(s));
  }

  periods() {
    const array = [];
    for (let i = 4; i <= this.maxPeriod; i++) {
      array.push(i);
    }
    return array;
  }

  changePeriod(periodId) {
    this.selectedPeriod = periodId;

    this.zoomService
      .get(this.zoomInfo, this.selectedPeriod)
      .subscribe((s: any) => {
        this.modalZones = [];
        this.modalZones.push(
          new ZoneItem(
            s.zoneType,
            s.title,
            s.dataSource,
            s.error,
            s.width,
            true,
          ),
        );
      });
  }

  open(item: any) {
    item.zoomed = true;

    if (item.periodId) {
      this.displayPeriodSelector = true;
      this.maxPeriod = item.periodId;
      this.selectedPeriod = this.maxPeriod;
    } else {
      this.displayPeriodSelector = false;
      this.maxPeriod = 4;
    }

    this.zoomService.getTexts().subscribe((s) => (this.texts = s));

    this.zoomInfo = item;
    this.zoomService.get(item, this.selectedPeriod).subscribe((s: any) => {
      this.modalZones = [];
      this.modalZones.push(
        new ZoneItem(s.zoneType, s.title, s.dataSource, s.error, s.width, true),
      );
      this.modalService.open(this.content, {
        ariaLabelledBy: "modal-basic-title",
        windowClass: "modal-full modal-dialog-scrollable",
        size: "xl",
      });
      this.title = s.title;
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
